import { pushDatalayer } from '../utilities/datalayer';

const checkPageDataLayerAwait = () => {
    if (window.pageDataLayerAwait?.length > 0) return;

    pushDatalayer({
        page_event: 'page_data',
        ...window.pageDataLayer,
    });
}

if (typeof window.pageDataLayer !== 'undefined') {
    window.pageDataLayerAwait = window.pageDataLayerAwait || [];
    window.pageDataLayerAwait.forEach(awaitEvent => {
        window.addEventListener(awaitEvent, () => {
            window.pageDataLayerAwait = window.pageDataLayerAwait?.filter(event => event !== awaitEvent) || [];
            checkPageDataLayerAwait();
        });
    });

    checkPageDataLayerAwait();
}
